// Add to Cart Form - Vanilla JS Version
document.addEventListener('DOMContentLoaded', function () {
  const addToCartFormSelector = "#add-to-cart-form";
  const productOptionSelector = addToCartFormSelector + " [name*=option]";

  // Preserve the original src and lightbox href of the first slide so we can
  // restore them when the selected variant has no featured_image.
  const firstSlideImg = document.querySelector('#myImg');
  const defaultSlideSrc = firstSlideImg ? firstSlideImg.src : '';
  const firstSlideLink = firstSlideImg ? firstSlideImg.closest('a.lightbox-link') : null;
  const defaultLinkHref = firstSlideLink ? firstSlideLink.getAttribute('href') : '';

  // Helper functions to replace jQuery functionality
  function getElement(selector) {
    return document.querySelector(selector);
  }

  function getAllElements(selector) {
    return document.querySelectorAll(selector);
  }

  function closest(element, selector) {
    return element.closest(selector);
  }

  function serializeForm(form) {
    const formData = new FormData(form);
    const serialized = [];
    for (let [name, value] of formData) {
      serialized.push({ name, value });
    }
    return serialized;
  }

  // Helper function for making requests (kept for future use)
  // function makeRequest(method, url, data = null, isJson = true) {
  //   const options = {
  //     method: method,
  //     headers: {
  //       'Content-Type': isJson ? 'application/json' : 'application/x-www-form-urlencoded',
  //     },
  //   };

  //   if (data) {
  //     if (isJson) {
  //       options.body = JSON.stringify(data);
  //     } else {
  //       options.body = data;
  //     }
  //   }

  //   return fetch(url, options);
  // }

  function triggerCustomEvent(element, eventName, detail = null) {
    const event = new CustomEvent(eventName, { detail, bubbles: true });
    element.dispatchEvent(event);
  }

  const productForm = {
    onProductOptionChanged: function (event) {
      const form = closest(event.target, addToCartFormSelector);
      const selectedVariant = productForm.getActiveVariant(form);

      // Trigger form change event with the selected variant
      triggerCustomEvent(form, 'form:change', selectedVariant);


      // Display the image associated with the selected variant
      const productImage = getElement('.product-image');
      if (selectedVariant.featured_media && selectedVariant.featured_media.preview_image && selectedVariant.featured_media.preview_image.src) {
        if (productImage) productImage.src = selectedVariant.featured_media.preview_image.src;
      } else {
        if (productImage) productImage.src = 'default-image.jpg';
      }

      // Update the thumbnail image and keep the lightbox link href in sync
      // so the magnifier opens the correct variant image (not the original slide 1).
      const myImg = getElement('#myImg');
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        if (myImg) {
          myImg.src = selectedVariant.featured_image.src;
          const parentLink = myImg.closest('a.lightbox-link');
          if (parentLink) parentLink.setAttribute('href', selectedVariant.featured_image.src);
        }
      } else if (myImg && defaultSlideSrc) {
        myImg.src = defaultSlideSrc;
        if (firstSlideLink && defaultLinkHref) firstSlideLink.setAttribute('href', defaultLinkHref);
      }

      // Update the slideshow to reflect the selected variant
      function updateSlideshowForVariant(variantId) {
        const slides = Array.from(getAllElements('.mySlides'));
        let firstMatchIndex = -1;

        for (let i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-variant') === variantId.toString()) {
            firstMatchIndex = i;
            break;
          }
        }

        if (typeof slideIndex !== 'undefined' && typeof showDivs !== 'undefined') {
          slideIndex = firstMatchIndex !== -1 ? firstMatchIndex + 1 : 1;
          showDivs(slideIndex);
        }
      }

      updateSlideshowForVariant(selectedVariant.id);

      // Custom label functionality
      function updateCharCount() {
        const messageField = getElement("#message");
        if (messageField) {
          const maxLength = parseInt(messageField.getAttribute("maxlength"));
          const currentLength = messageField.value.length;
          const remainingChars = maxLength - currentLength;
          const leftCharsElement = getElement(".left-characters");
          if (leftCharsElement) leftCharsElement.textContent = remainingChars;
        }
      }

      function updateTextareaAttributes(size) {
        const isSmall = (size === "Pequena" || size === "Small");
        const maxLength = isSmall ? 10 : 90;
        const messageField = getElement("#message");
        
        if (messageField) {
          messageField.setAttribute("maxlength", maxLength);
          
          if (isSmall) {
            messageField.value = '';
          } else if (messageField.value.length > maxLength) {
            messageField.value = messageField.value.substring(0, maxLength);
          }

          updateCharCount();
        }
      }

      // Get the size from the selected variant title
      const titleParts = selectedVariant.title.split(" / ");
      const size = titleParts[1];

      // Call the function to update textarea attributes initially
      updateTextareaAttributes(size);

      // Attach event listener to textarea for input event
      const messageField = getElement("#message");
      if (messageField) {
        messageField.addEventListener("input", updateCharCount);
      }
    },

    getActiveVariant: function (form) {
      const variantsData = form.getAttribute("data-variants");
      const variants = JSON.parse(decodeURIComponent(variantsData));
      const formData = serializeForm(form);
      const formOptions = {
        option1: null,
        option2: null,
        option3: null,
      };
      let selectedVariant = null;

      formData.forEach(function(item) {
        if (item.name.indexOf("option") !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      variants.forEach(function(variant) {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          return;
        }
      });

      return selectedVariant;
    },

    validate: function (event) {
      const form = event.target;
      const selectedVariant = event.detail;
      const hasVariant = selectedVariant !== null;
      const canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0;
      
      const idField = form.querySelector(".js-variant-id");
      const addToCartButton = form.querySelector("#add-to-cart-button");
      const priceElement = form.querySelector(".js-price");
      const quantityField = form.querySelector(".js-quantity-field-sticky");
      
      
      let formatedVariantPrice, priceHtml;

      if (hasVariant) {
        idField.value = selectedVariant.id;
        formatedVariantPrice = "€" + (selectedVariant.price / 100).toFixed(2);
        priceHtml = '<span class="money">' + formatedVariantPrice + "</span>";

        // Price calculation available if needed for future features

        window.history.replaceState(null, null, "?variant=" + selectedVariant.id);
      } else {
        if (priceElement) {
          priceHtml = priceElement.getAttribute("data-default-price");
        }
      }

      if (hasVariant && quantityField) {
        quantityField.value = 1;
        quantityField.setAttribute('max', selectedVariant.inventory_quantity);
        updateStickyQuantityButtonsState(quantityField);
      }

      if (canAddToCart) {
        if (idField) {
          idField.value = selectedVariant.id;
        }
        if (addToCartButton) addToCartButton.disabled = false;
      } else {
        if (idField) {
          idField.value = "";
        }
        if (addToCartButton) addToCartButton.disabled = true;
      }

      if (priceElement) priceElement.innerHTML = priceHtml;
    },

    init: function () {
      document.addEventListener("change", function(event) {
        if (event.target.matches(productOptionSelector)) {
          productForm.onProductOptionChanged(event);
        }
      });

      document.addEventListener("form:change", function(event) {
        if (event.target.matches(addToCartFormSelector)) {
          productForm.validate(event);
        }
      });
      
      // Direct listener for variant radio buttons with specific class
      document.addEventListener("change", function(event) {
        if (event.target.matches('.js-variant-radio-new')) {
          const form = closest(event.target, addToCartFormSelector);
          if (form) {
            productForm.onProductOptionChanged(event);
          }
        }
      });
      
      // Also ensure variant ID is updated immediately when radio button changes
      document.addEventListener("change", function(event) {
        if (event.target.matches('input[type="radio"][name*="option"]')) {
          const form = closest(event.target, addToCartFormSelector);
          if (form) {
            const selectedVariant = productForm.getActiveVariant(form);
            const idField = form.querySelector(".js-variant-id");
            
            if (selectedVariant && idField) {
              idField.value = selectedVariant.id;
              // Also trigger the form change event
              triggerCustomEvent(form, 'form:change', selectedVariant);
            }
          }
        }
      });
    },
  };

  productForm.init();

  // Quantity Field Sticky functionality
  function updateStickyQuantityButtonsState(field) {
    const form = closest(field, "form");
    if (!form) return;
    const quantityText = form.querySelector(".js-quantity-text-sticky");
    const minusButton = form.querySelector(".js-quantity-button-sticky.minus");
    const plusButton = form.querySelector(".js-quantity-button-sticky.plus");
    const value = parseInt(field.value);
    const max = parseInt(field.getAttribute("max"));

    if (quantityText) quantityText.textContent = field.value;
    if (minusButton) minusButton.disabled = value <= 1;
    if (plusButton) plusButton.disabled = !isNaN(max) && value >= max;
  }

  document.addEventListener("change", function(event) {
    if (event.target.matches(".js-quantity-field-sticky")) {
      updateStickyQuantityButtonsState(event.target);
    }
  });

  document.addEventListener("click", function(event) {
    if (event.target.matches(".js-quantity-button-sticky")) {
      const button = event.target;
      const form = closest(button, "form");
      const quantity = form.querySelector(".js-quantity-field-sticky");
      const quantityValue = parseInt(quantity.value);
      const max = parseInt(quantity.getAttribute("max"));
      const variantPrice = getElement(".js-price").getAttribute("data-variant-price");
      const finalPrice = getElement(".js-price-final");

      if (button.classList.contains("plus") && (isNaN(max) || quantityValue < max)) {
        quantity.value = quantityValue + 1;
        updateStickyQuantityButtonsState(quantity);
        if (finalPrice) finalPrice.textContent = "€" + quantity.value * (variantPrice / 100);
      } else if (button.classList.contains("minus") && quantityValue > 1) {
        quantity.value = quantityValue - 1;
        updateStickyQuantityButtonsState(quantity);
        if (finalPrice) finalPrice.textContent = "€" + quantity.value * (variantPrice / 100);
      }
    }
  });

  // Mini Cart functionality
  const miniCartContentSelector = ".js-mini-cart-contents";

  const ajaxify = {
    onAddToCart: function (event) {
      event.preventDefault();
      const form = event.target;
      const formData = new FormData(form);

      // Preload the variant image immediately on click — before add.js even responds,
      // so the image has the full add.js + section-fetch round trip to download.
      try {
        const variantsData = form.getAttribute('data-variants');
        const idField = form.querySelector('.js-variant-id');
        if (variantsData && idField && idField.value) {
          const variants = JSON.parse(decodeURIComponent(variantsData));
          const variant = variants.find(v => String(v.id) === String(idField.value));
          if (variant && variant.featured_image && variant.featured_image.src) {
            const src = variant.featured_image.src;
            const link = document.createElement('link');
            link.rel = 'preload';
            link.as = 'image';
            link.href = src.includes('?') ? src + '&width=300' : src + '?width=300';
            document.head.appendChild(link);
          }
        }
      } catch (e) {}

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
      .then(response => response.json())
      .then(() => {
        const contentReady = ajaxify.onCartUpdated();
        Promise.race([
          contentReady,
          new Promise(resolve => setTimeout(resolve, 350))
        ]).then(() => ajaxify.openCart());
      })
      .catch(error => ajaxify.onError(error));
    },

    onCartUpdated: function () {
      const miniCartFieldset = getElement(miniCartContentSelector + " .js-cart-fieldset");
      if (miniCartFieldset) miniCartFieldset.disabled = true;

      const cartNew = getElement('#cart-new');
      const cartAlreadyOpen = document.documentElement.classList.contains('mini-cart-open');
      if (!cartAlreadyOpen && cartNew) cartNew.classList.add('loading');

      let url = "/cart?sections=cart-mini-ajax";
      if (typeof Shopify !== 'undefined' && Shopify.locale) url = "/" + Shopify.locale + "/cart?sections=cart-mini-ajax";

      return new Promise((resolve) => {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-mini-ajax'], 'text/html');
          const dataCartContents = doc.querySelector(".js-cart-page-contents");

          if (dataCartContents) {
            const dataCartHtml = dataCartContents.innerHTML;
            const dataCartItemCount = dataCartContents.getAttribute("data-cart-item-count");
            const miniCartContents = getElement(miniCartContentSelector);
            const cartItemCountElements = getAllElements(".js-cart-item-count");
            const cartCountInfoElements = getAllElements(".cart_count_info");

            cartItemCountElements.forEach(el => {
              el.dataset.pendingCount = dataCartItemCount;
            });
            if (miniCartContents) {
              miniCartContents.innerHTML = dataCartHtml;
              miniCartContents.setAttribute("data-cart-item-count", dataCartItemCount);
            }
            cartCountInfoElements.forEach(el => el.textContent = dataCartItemCount);
            if (cartNew) cartNew.classList.remove('loading');
            resolve();
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            animateShippingBar();

            // Restore gift wrap checkbox states from server-rendered quantity
            (function() {
              const fieldsetForRestore = getElement('#cart-new .js-cart-fieldset');
              const restoredQty = fieldsetForRestore ? parseInt(fieldsetForRestore.dataset.giftWrapQuantity || '0', 10) : 0;
              document.querySelectorAll('#cart-new .upsell-wrap').forEach(function(cb, i) {
                cb.checked = i < restoredQty;
              });
            })();

            // Reconcile gift wrap: if a product was deleted the server qty may
            // exceed the number of items still in the cart. Cap it to match.
            const giftWrapVariantId = cartNew ? cartNew.dataset.giftWrapVariantId : null;
            if (giftWrapVariantId) {
              const fieldset = getElement('#cart-new .js-cart-fieldset');
              const serverQty = fieldset ? parseInt(fieldset.dataset.giftWrapQuantity || '0', 10) : 0;
              const checkedQty = document.querySelectorAll('#cart-new .upsell-wrap:checked').length;
              if (serverQty !== checkedQty) {
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: { [giftWrapVariantId]: checkedQty } }),
                })
                .then(r => r.json())
                .then(() => ajaxify.onCartUpdated())
                .catch(() => {});
              }
            }

            // Gift wrap functionality
            function handleGiftWrap() {
              const miniCart = getElement('#mini-cart');
              if (!miniCart) return;

              const existingGiftWrap = getElement('.gift-wrap');
              if (existingGiftWrap) existingGiftWrap.remove();

              const giftWrapVariantId = miniCart.dataset.giftWrapVariantId || '46378171990361';
              const giftWrapPrice = miniCart.dataset.giftWrapPrice;
              const giftWrapDescription = miniCart.dataset.giftWrapDescription;

              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  const giftWrapInCart = cart.items.some(item => String(item.variant_id) === String(giftWrapVariantId));
                  if (giftWrapInCart) return;

                  const giftWrapItemHtml = `
                    <div class="gift-wrap">
                      <div class="left-side">
                        <img src="https://cdn.shopify.com/s/files/1/0550/0964/0503/files/gift-wrap-icon.svg??v=${Date.now()}" onerror="this.src='https://cdn.shopify.com/s/files/1/0550/0964/0503/files/gift-wrap-icon.svg'">
                        <p>${giftWrapDescription}</p>
                      </div>
                      <div class="right-side">
                        <p>${giftWrapPrice}</p>
                        <input type="checkbox" class="upsell-wrap" value="${giftWrapVariantId}">
                      </div>
                    </div>`;

                  const subtotal = getElement('div.subtotal');
                  if (subtotal) {
                    subtotal.insertAdjacentHTML('beforebegin', giftWrapItemHtml);
                    const upsellWrap = getElement('.upsell-wrap');
                    if (upsellWrap) upsellWrap.addEventListener('change', updateGiftWrap);
                  }
                });
            }

            function updateGiftWrap(event) {
              const checkbox = event.target;
              const isGiftWrapChecked = checkbox.checked;
              const variantId = checkbox.value;

              if (isGiftWrapChecked) {
                // Increment by 1 — works whether gift wrap is already in cart or not
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: variantId, quantity: 1 }),
                })
                .then(r => r.json())
                .then(() => ajaxify.onCartUpdated())
                .catch(() => {});
              } else {
                // Set to the count of remaining checked boxes, not 0
                const remainingQty = document.querySelectorAll('.upsell-wrap:checked').length;
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: { [variantId]: remainingQty } }),
                })
                .then(r => r.json())
                .then(() => ajaxify.onCartUpdated())
                .catch(() => {});
              }
            }

            handleGiftWrap();

            if (parseInt(dataCartItemCount) > 0) {
              ajaxify.openCart();
            } else {
              ajaxify.closeCart();
              // Clear URL variant parameter and reset form state when cart becomes empty
              if (window.location.search.includes('variant=')) {
                window.history.replaceState(null, null, window.location.pathname);
                
                // Also reset the form to clear any cached variant selection
                const form = getElement(addToCartFormSelector);
                if (form) {
                  // Reset variant ID field
                  const idField = form.querySelector(".js-variant-id");
                  if (idField) idField.value = "";
                  
                  // Reset all option selections to first available option
                  const optionSelects = form.querySelectorAll('select[name*="option"]');
                  optionSelects.forEach(select => {
                    if (select.options.length > 1) {
                      select.selectedIndex = 1; // Skip the disabled placeholder option
                    }
                  });
                  
                  // Reset radio buttons to first available option
                  const radioGroups = {};
                  const radioInputs = form.querySelectorAll('input[type="radio"][name*="option"]');
                  radioInputs.forEach(radio => {
                    if (!radioGroups[radio.name]) {
                      radioGroups[radio.name] = [];
                    }
                    radioGroups[radio.name].push(radio);
                  });
                  
                  // Check the first radio in each group
                  Object.values(radioGroups).forEach(group => {
                    group.forEach(radio => radio.checked = false);
                    if (group.length > 0) {
                      group[0].checked = true;
                    }
                  });
                  
                  // Trigger change event to update the form
                  const firstOption = form.querySelector('select[name*="option"], input[type="radio"][name*="option"]:checked');
                  if (firstOption) {
                    firstOption.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }
            }
          } else {
            if (cartNew) cartNew.classList.remove('loading');
            resolve();
          }
        })
        .catch(() => {
          if (cartNew) cartNew.classList.remove('loading');
          resolve();
        });
      });
    },

    onError: function (error) {
      // Error adding to cart - handle silently or show user-friendly message
    },

    onCartButtonClick: function (event) {
      event.preventDefault();
      const isCartOpen = document.documentElement.classList.contains("mini-cart-open");

      if (!isCartOpen) {
        ajaxify.openCart();
      } else {
        ajaxify.closeCart();
      }
    },

    openCart: function () {
      document.documentElement.classList.add("mini-cart-open");
      setTimeout(animateShippingBar, 400);
    },

    closeCart: function () {
      document.documentElement.classList.remove("mini-cart-open");
      // Fire the digit flip after the drawer has closed (500ms transition)
      setTimeout(function() {
        getAllElements('.js-cart-item-count').forEach(el => {
          const pending = el.dataset.pendingCount;
          if (pending === undefined || pending === el.textContent.trim()) {
            delete el.dataset.pendingCount;
            return;
          }
          // Old number exits up
          const leaving = document.createElement('span');
          leaving.textContent = el.textContent;
          leaving.className = 'js-cart-digit-leaving';
          el.parentElement.appendChild(leaving);
          leaving.addEventListener('animationend', () => leaving.remove(), { once: true });
          // New number rises in from below simultaneously
          el.textContent = pending;
          delete el.dataset.pendingCount;
          el.classList.remove('js-cart-digit-entering');
          void el.offsetWidth;
          el.classList.add('js-cart-digit-entering');
          el.addEventListener('animationend', () => el.classList.remove('js-cart-digit-entering'), { once: true });
        });
      }, 600);
    },

    init: function () {
      document.addEventListener("submit", function(event) {
        if (event.target.matches(addToCartFormSelector)) {
          ajaxify.onAddToCart(event);
        }
      });

      document.addEventListener("click", function(event) {
        if (event.target.matches(".js-cart-link") || event.target.closest(".js-cart-link")) {
          ajaxify.onCartButtonClick(event);
        } else if (event.target.matches(".js-mini-cart-btn-close") || event.target.closest(".js-mini-cart-btn-close")) {
          ajaxify.onCartButtonClick(event);
        }
      });
    },
  };

  function animateShippingBar() {
    document.querySelectorAll('.cart-new__shipping-fill').forEach(function(fill) {
      const target = fill.dataset.width;
      if (target === undefined) return;
      requestAnimationFrame(function() {
        fill.style.width = target + '%';
      });
    });
  }

  ajaxify.init();

  // Gift wrap for #cart-new — document-level delegation covers server-rendered
  // and AJAX-replaced checkboxes alike.
  // Uses the count of checked boxes as the target quantity so that unchecking
  // one item doesn't remove wrap from all items.
  document.addEventListener('change', function(event) {
    if (!event.target.matches('#cart-new .upsell-wrap')) return;

    const variantId = event.target.value;
    const checkedCount = document.querySelectorAll('#cart-new .upsell-wrap:checked').length;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: checkedCount } }),
    })
    .then(r => r.json())
    .then(() => ajaxify.onCartUpdated())
    .catch(() => {});
  });

  // Close Mini cart when clicking on dark background
  document.addEventListener("click", function(event) {
    if (event.target.matches(".dark-background")) {
      ajaxify.closeCart();
    }
  });

  // Quantity picker functionality
  const quantityFieldSelector = ".js-quantity-field";
  const quantityButtonSelector = ".js-quantity-button";
  const quantityPickerSelector = ".js-quantity-picker";

  const quantityPicker = {
    onButtonClick: function (event) {
      const button = event.target.closest('.js-quantity-button');
      if (!button) return;
      
      const picker = closest(button, quantityPickerSelector);
      if (!picker) return;
      
      const quantity = picker.querySelector(".js-quantity-field");
      if (!quantity) return;
      
      const quantityValue = parseInt(quantity.value);
      const maxAttr = quantity.getAttribute("max");
      const max = maxAttr !== null ? parseInt(maxAttr) : null;
      const min = quantity.getAttribute("min") ? parseInt(quantity.getAttribute("min")) : 0;

      if (button.classList.contains("plus") && (max === null || quantityValue + 1 <= max)) {
        quantity.value = quantityValue + 1;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (button.classList.contains("minus") && quantityValue > min) {
        quantity.value = quantityValue - 1;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },

    onChange: function (event) {
      const field = event.target;
      const picker = closest(field, quantityPickerSelector);
      const quantityText = picker.querySelector(".js-quantity-text");
      const shouldDisableMinus = parseInt(field.value) === parseInt(field.getAttribute("min"));
      const maxAttr = field.getAttribute("max");
      const shouldDisablePlus = maxAttr !== null && parseInt(field.value) >= parseInt(maxAttr);
      const minusButton = picker.querySelector(".js-quantity-button.minus");
      const plusButton = picker.querySelector(".js-quantity-button.plus");

      if (quantityText) quantityText.textContent = field.value;

      if (shouldDisableMinus) {
        if (minusButton) minusButton.disabled = true;
      } else if (minusButton && minusButton.disabled === true) {
        minusButton.disabled = false;
      }

      if (shouldDisablePlus) {
        if (plusButton) plusButton.disabled = true;
      } else if (plusButton && plusButton.disabled === true) {
        plusButton.disabled = false;
      }
    },

    init: function () {
      document.addEventListener("click", function(event) {
        if (event.target.matches(quantityButtonSelector) || event.target.closest(quantityButtonSelector)) {
          quantityPicker.onButtonClick(event);
        }
      });

      document.addEventListener("change", function(event) {
        if (event.target.matches(quantityFieldSelector)) {
          quantityPicker.onChange(event);
        }
      });
    },
  };

  quantityPicker.init();

  // Product quantity picker functionality
  const quantityForm = getElement('.quantity-picker-product');
  if (quantityForm) {
    const quantity = quantityForm.querySelector('.js-quantity-field-new');
    const plusButton = quantityForm.querySelector('.js-quantity-button-product.plus');
    const minusButton = quantityForm.querySelector('.js-quantity-button-product.minus');

    function updateMaxQuantity(selectedVariant) {
      if (selectedVariant && quantity) {
        quantity.setAttribute('max', selectedVariant.inventory_quantity);
      } else if (quantity) {
        quantity.setAttribute('max', '1');
      }
    }

    function updateQuantityButtonsState() {
      if (!quantity) return;
      
      const availableStock = parseInt(quantity.getAttribute('max'));
      const quantityValue = parseInt(quantity.value);

      if (plusButton) plusButton.disabled = quantityValue >= availableStock;
      if (minusButton) minusButton.disabled = quantityValue <= 1;

      const quantityTextNew = quantityForm.querySelector('.js-quantity-text-new');
      if (quantityTextNew) quantityTextNew.textContent = quantityValue;
    }

    updateQuantityButtonsState();

    if (plusButton) {
      plusButton.addEventListener('click', function () {
        const availableStock = parseInt(quantity.getAttribute('max'));
        const quantityValue = parseInt(quantity.value);

        if (quantityValue < availableStock) {
          quantity.value = quantityValue + 1;
          updateQuantityButtonsState();
        }
      });
    }

    if (minusButton) {
      minusButton.addEventListener('click', function () {
        const quantityValue = parseInt(quantity.value);

        if (quantityValue > 1) {
          quantity.value = quantityValue - 1;
          updateQuantityButtonsState();
        }
      });
    }

    if (quantity) {
      quantity.addEventListener('change', function () {
        const newQuantity = parseInt(this.value);
        const availableStock = parseInt(quantity.getAttribute('max'));

        if (!isNaN(newQuantity) && newQuantity >= 1 && newQuantity <= availableStock) {
          this.value = newQuantity;
        } else {
          this.value = 1;
        }

        updateQuantityButtonsState();
      });
    }

    document.addEventListener('form:change', function(event) {
      if (event.target.matches(addToCartFormSelector)) {
        if (quantity) quantity.value = 1;
        updateMaxQuantity(event.detail);
        updateQuantityButtonsState();
      }
    });
  }

  // Line Item functionality
  const removeLineSelector = ".js-remove-line";
  const lineQuantitySelector = ".js-line-quantity";

  const lineItem = {
    isInMiniCart: function (element) {
      return closest(element, miniCartContentSelector) !== null;
    },

    onLineQuantityChanged: function (event) {
      const quantity = event.target.value;
      const id = event.target.id.replace("updates_", '');
      const changes = {
        quantity: quantity,
        id: id,
      };
      
      const isInMiniCart = lineItem.isInMiniCart(event.target);

      if (isInMiniCart) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(changes),
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok');
        })
        .then(() => ajaxify.onCartUpdated())
        .catch(error => {
        });
      }
    },

    onLineRemoved: function (event) {
      const isInMiniCart = lineItem.isInMiniCart(event.target);

      if (isInMiniCart) {
        event.preventDefault();
        const removeLink = event.target.closest('.js-remove-line');
        removeLink.classList.add('loading');
        const removeQuery = removeLink.getAttribute("href").split("change?")[1];

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: removeQuery,
        })
        .then(response => {
          if (response.ok) return response.json();
          throw new Error('Network response was not ok');
        })
        .then(cart => {
          // Reconcile gift wrap before re-render so there is no flash
          const cartNewEl = getElement('#cart-new');
          const giftWrapId = cartNewEl ? cartNewEl.dataset.giftWrapVariantId : null;
          if (!giftWrapId) return ajaxify.onCartUpdated();

          const giftWrapItem = cart.items.find(i => String(i.variant_id) === String(giftWrapId));
          if (!giftWrapItem) return ajaxify.onCartUpdated();

          const nonWrapCount = cart.items.filter(i => String(i.variant_id) !== String(giftWrapId)).length;
          if (giftWrapItem.quantity > nonWrapCount) {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: { [giftWrapId]: nonWrapCount } }),
            })
            .then(r => r.json())
            .then(() => ajaxify.onCartUpdated());
          }
          return ajaxify.onCartUpdated();
        })
        .catch(error => {
          removeLink.classList.remove('loading');
        });
      }
    },

    init: function () {
      document.addEventListener("click", function(event) {
        if (event.target.matches(removeLineSelector) || event.target.closest(removeLineSelector)) {
          lineItem.onLineRemoved(event);
        }
      });

      document.addEventListener("change", function(event) {
        if (event.target.matches(lineQuantitySelector)) {
          lineItem.onLineQuantityChanged(event);
        }
      });
    },
  };

  lineItem.init();
});